<script setup lang="ts">
import { onMounted, ref } from "vue";
import { useRouter } from "vue-router";

import { useAuthStore } from "@/stores";

const { logout } = useAuthStore();
const router = useRouter();

const display = ref(false);

onMounted(async () => {
  setTimeout(() => (display.value = true), 75);

  try {
    await logout();
  } finally {
    router.push({ name: "login", query: {} });
  }
});
</script>

<template>
  <main class="container p-0 d-flex flex-column justify-content-center align-items-center">
    <div v-if="display" class="row justify-content-center mx-0 w-100">
      <div class="col-12 col-lg-5 py-4 bg-white rounded">
        <h1 class="m-0 text-center">{{ $t("logout.title") }}</h1>
      </div>
    </div>
  </main>
</template>
